module.exports = __webpack_public_path__ + "assets/da5896030ffac0e4bcf5c3c3b38c604a.mp3";